export default __webpack_public_path__ + "static/media/msf_background_m1.c5d43d19.jpg";